import { UUID } from 'angular2-uuid';

/** 產出首頁模板預設資料 */
export function generateTemplateDefaultData(tmpSelector: string): any {
  switch (tmpSelector) {
    case 'template-040':
      return {
        selector: 'template-040',
        themeClass: 'basic',
        data: {
          bootstrapVersion: '4.6.2',
          css: [],
          js: [],
          themeColor: '#008080',
        },
        sections: [
          generateSectionDefaultData('index-banner-03', 0),
          generateSectionDefaultData('index-collection-01', 1),
          generateSectionDefaultData('index-subject-01', 2),
          generateSectionDefaultData('index-search-01', 3),
          generateSectionDefaultData('index-subject-02', 4),
          generateSectionDefaultData('index-subject-03', 5),
          generateSectionDefaultData('index-subject-04', 6),
          generateSectionDefaultData('index-subject-05', 7),
          generateSectionDefaultData('index-subject-06', 8),
          generateSectionDefaultData('index-subject-07', 9),
          generateSectionDefaultData('index-quiz-01', 10),
          generateSectionDefaultData('index-article-01', 11),
          generateSectionDefaultData('index-banner-02', 12),
        ],
      };
    case 'template-001':
      return {
        selector: 'template-001',
        themeClass: 'basic',
        data: {
          bootstrapVersion: '5.3.3',
          css: [],
          js: [],
          themeColor: '#4c4a48',
        },
        sections: [
          generateSectionDefaultData('index-search-02', 1),
          generateSectionDefaultData('index-article-02', 2),
          generateSectionDefaultData('index-banner-04', 3),
          generateSectionDefaultData('index-subject-08', 4),
          generateSectionDefaultData('index-subject-09', 5),
          generateSectionDefaultData('index-subject-08', 6),
          generateSectionDefaultData('index-collection-03', 7),
          generateSectionDefaultData('index-collection-02', 8),
          generateSectionDefaultData('index-subject-10', 9),
          generateSectionDefaultData('index-quiz-02', 10),
        ],
      };
  }
}

/** 產出首頁區塊預設資料 */
export function generateSectionDefaultData(secSelector: string, index: number = 0): any {
  switch (secSelector) {
    default:
      return {
        selector: secSelector,
        data: {
          enable: true,
          uuid: UUID.UUID(),
          index: index,
          cannotDel: true,
          wowSetting: {
            turnOn: true,
            animate: 'slideInUp',
          },
        },
      };
  }
}
